module.exports = __webpack_public_path__ + "static/media/home-4.aa4a03d1.jpg";